// *** Sign up Component ****
import React, { useEffect, useState, useRef } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { Stepper, Step } from 'react-form-stepper';
import "../../assets/css/style.css";
import { ApiHelper } from "../../helpers/ApiHelper";
import { API } from "../../services/api";
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import "../../assets/css/signup.css";
import { Link } from "react-router-dom";
import "../../assets/css/text-limit.css";
import { checkCharacterLimit } from "../../utils/textLimiter";
import Axios from 'axios';
import Validation from "../../commonComponents/Validation";
import moment from "moment";
import Spinner from "../../commonComponents/Spinner";
import Calender from "../../assets/icons/calendar.svg"
import thumb from "../../assets/img/post/add-pop-thumb.svg"
import { months } from "../../utils/Month";

const SignUp = (props) => {
    const MAX_ORG_NAME_LENGTH = 100;
    const [orgNameLimit, setOrgNameLimit] = useState({
        isOverLimit: false,
        remaining: MAX_ORG_NAME_LENGTH,
    });
    const MAX_COMMUNITY_LENGTH = 100;
    const [communityLimit, setCommunityLimit] = useState({
        isOverLimit: false,
        remaining: MAX_COMMUNITY_LENGTH,
    });
    // --- New Constants for Anti-bot/Overload ---
    const MAX_NUMERIC_INPUT_LENGTH = 25; 
    // -------------------------------------------

    const Group = require("../../assets/img/Featured icon.jpg");
    const [step, setStep] = useState(0);
    const [pswerror, setPswError] = useState(false);
    const [userType, setUserType] = useState('individual');
    const [contactName, setContactName] = useState('');
    const [website, setWebsite] = useState('');
    const [cell, setCell] = useState('');
    const [einTax, setEinTax] = useState('');
    const [orgType, setOrgType] = useState('');
    const [community, setCommunity] = useState('');
    const [communityId, setCommunityId] = useState('');
    const [firstName, setFirstName] = useState(props.socialName ? props.socialName : "");
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState(props.socialMail ? props.socialMail : "");
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [organiszation, setOrganization] = useState('');
    const [zip, setZip] = useState('');
    const [bio, setBio] = useState('');
    const [gender, setGender] = useState('');
    const [dob, setDob] = useState('');
    const [dobError, setDobError] = useState('');
    const [communityMemberTypes, setCommunityMemberTypes] = useState([]);
    const [communityArr, setCommunityArr] = useState([]);
    const [selectedMemberType, setSelectedMemberType] = useState('Select Member type');
    const [communitySelected, setCommunitySelected] = useState(false);
    const fileInputRef = useRef();
    const [selectedFile, setSelectedFile] = useState(null);
    const [emailError, setEmailError] = useState(false);
    const [isEmailExist, setIsEmailExist] = useState(false);
    const [isCommunityExist, setIsCommunityExist] = useState(false);
    const [isNewCommunity, setIsNewCommunity] = useState(false);
    const [newCommunity, setNewCommunity] = useState('');
    const [stepOneError, setStepOneError] = useState(false);
    const [stepTwoError, setStepTwoError] = useState(false);
    const [stepThreeError, setStepThreeError] = useState(false);
    const [signUpStatus, setSignUpStatus] = useState('');
    const [loader, setLoader] = useState(false);
    const [communityLoader, setCommunityLoader] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const [location, setLocation] = useState('');
    const [country, setCountry] = useState('681dde46519da80203bdf80f');
    const [countryId, setCountryId] = useState('');
    const [countryArr, setCountryArr] = useState([]);
    const [signupArr, setSignupArr] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
    const [dateError, setDateError] = useState('');
    const [month, setMonth] = useState('');
    const [day, setDay] = useState('');
    const [year, setYear] = useState('');
    const AUSTRALIA_ID = "681dde46519da80203bdf734";


    useEffect(() => {
        const remaining = MAX_ORG_NAME_LENGTH - organiszation.length;
        setOrgNameLimit({
            isOverLimit: remaining <= 0,
            remaining: remaining >= 0 ? remaining : 0,
        });
    }, [organiszation]);


    useEffect(() => {
        if (props.isSignUp) {
            getAllCommunityMemberTypes();
            getAllCountry();
        }
    }, [props.isSignUp])
    const getAllCommunityMemberTypes = async () => {
        const formData = {
            filter: "all"
        }
        await ApiHelper.post(API.getAllCommunityMemberTypes, formData)
            .then((resData) => {
                setCommunityMemberTypes(resData.data.data)
            })
            .catch((err) => {
                console.log(err, 'err');
            });
    }
    const getAllCountry = async () => {
        await ApiHelper.post(API.countriesList)
            .then((resData) => {
                setCountryArr(resData.data.data)
            })
            .catch((err) => {
                console.log(err, 'err');
            });
    }
    useEffect(() => {
        if (community !== '') {
            getAllCommunities(community)
        }
        else {
            setCommunityArr([])
            setCommunityId('')
            setIsNewCommunity(false)
        }
    }, [community])
    const getAllCommunities = async (community) => {
        setCommunityLoader(true);
        setHasSearched(false);
        const formData = {
            searchkey: community,
            hasrecommendedcommunity: false
        }
        try {
            await ApiHelper.post(API.getAllCommunities, formData)
                .then((resData) => {
                    setCommunityArr(resData.data.data)
                    if (resData.data.data.length === 0 && community !== '') {
                        setTimeout(() => {
                            setHasSearched(true);
                        }, 300);
                    }
                })
                .catch((err) => {
                    console.log(err, 'err');
                });
        }
        catch (err) {
            console.log(err);
        } finally {
            setCommunityLoader(false);
        }
    }
    const handleCommunityVerification = async (event) => {
        const value = event.target.value;
        setIsCommunityExist(false)
        const formData = {
            community: value
        }
        await ApiHelper.post(API.checkCommunityExist, formData)
            .then((resData) => {
                setIsCommunityExist(resData.data.status)

            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleEmailVerification = async (event) => {
        const value = event.target.value;
        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        const result = pattern.test(value);
        if (result === false) {
            setEmailError(true)
        }
        else {
            setEmailError(false)
            const formData = {
                email: value
            }
            await ApiHelper.post(API.checkEmailExist, formData)
                .then((resData) => {
                    setIsEmailExist(resData.data.status)

                })
                .catch((err) => {
                    console.log(err);
                })
        }
    }
    const handlePassword = (event) => {
        const value = event.target.value;
        if (password === value) {
            setPswError(false)
        }
        else {
            setPswError(true)
        }
    }
    const handleFocus = () => {
        setIsCalendarOpen(true);
    };
    const validateDob = (selectedDate) => {
    if (!selectedDate) return false;

    const today = new Date();

    // 👇 Decide age limit based on country
    const minAge = country === AUSTRALIA_ID ? 16 : 13;

    const minDate = new Date(
        today.getFullYear() - minAge,
        today.getMonth(),
        today.getDate()
    );

    return selectedDate <= minDate;
};
   

    const handleChange = (date) => {
        setDob(date);
        setDobError(false);

        setTimeout(() => {
            setIsCalendarOpen(false);
        }, 100);
    };

    useEffect(() => {
        const fetchLocation = async () => {
            if (zip) {
                const result = await getLocationFromZip(zip);
                setLocation(result);
            }
        };

        fetchLocation();
    }, [zip])
    const getLocationFromZip = async (zipCode) => {

        const apiKey = process.env.REACT_APP_ZIP_API
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${zipCode}&key=${apiKey}`;

        try {
            const response = await ApiHelper.get(url);

            // 🔒 Prevent accessing undefined when results are empty
            if (!response.data.results || response.data.results.length === 0) {
                console.warn('No results found for zip code:', zipCode);
                return '';
            }

            const components = response.data.results[0].address_components || [];

            const getComponent = (type) =>
                components.find((comp) => comp.types.includes(type))?.long_name || '';

            const streetNumber = getComponent('street_number');
            const route = getComponent('route');
            const city = getComponent('locality');
            const state = getComponent('administrative_area_level_1');
            const postalCode = getComponent('postal_code');
            const country = getComponent('country');

            const formattedAddress = [city, state, country].filter(Boolean).join(', ');

            return formattedAddress;
        } catch (error) {
            console.error('Geocoding API error:', error);
            return '';
        }
    };

    useEffect(() => {
        setDobError("")
      if (month && day && year) {
        const formattedDob = `${month}/${day.padStart(2, '0')}/${year}`;
        
        // Check if this is a valid date
        const parsedDate = new Date(formattedDob);
        const isValid =
          parsedDate instanceof Date &&
          !isNaN(parsedDate) &&
          parsedDate.getMonth() + 1 === parseInt(month) &&
          parsedDate.getDate() === parseInt(day) &&
          parsedDate.getFullYear() === parseInt(year);
    
        if (isValid) {
          setDob(formattedDob);
          setDateError(""); // ✅ clear error
        } else {
          setDob(""); // invalid date
          setDateError("Please enter a valid date"); // ❌ invalid
        }
      } else {
        setDob("");
        setDateError(""); // no error until all fields filled
      }
    }, [month, day, year]);
    const next = (step) => {

        if (step === 0) {
            let hasError = false;
            setCommunitySelected(false);
            setCommunityArr([])
            if (userType === 'individual') {
                if (selectedMemberType === "Select Member type") {
                    hasError = true;
                }

                if (!communityId && !isNewCommunity) {
                    hasError = true;
                }

                
                if (isNewCommunity) {
                    if (!newCommunity || isCommunityExist) {
                        hasError = true;
                    }
                }
            }

            if (userType === 'organization') {
                if (!contactName) hasError = true;
                if(isValidName(contactName)) hasError = true;
                if (!website) hasError = true;
                if (!cell) hasError = true;
                if (!einTax) hasError = true;
                if (!orgType) hasError = true;
                if (!communityId && !isNewCommunity) {
                    hasError = true;
                }
                if (isNewCommunity && !newCommunity) {
                    hasError = true;
                }
            }
            if (hasError) {
                setStepOneError(true);
            } else {
                setStepOneError(false);
                if (step < 2) {
                    setStep(step + 1);
                }
            }
        }
        else if (step === 1) {
            let hasError = false;
            if (email === '') {
                hasError = true;
            }
            if (!props.isSocial) {
                if (password === '' || confirmPassword === '' || password !== confirmPassword) {
                    hasError = true;
                    setPswError(true);
                }
                if(!isValidPassword(password))
                    {
               hasError = true;
                    }
            }
            if (email !== '' && (emailError || isEmailExist)) { 
               hasError = true;
                    }
            if (userType === 'individual') {
                if (firstName === '' || lastName === '') {
                    hasError = true;
                }
                if(isValidName(firstName)) hasError = true;
                if(isValidName(lastName)) hasError = true;
            } else if (userType === 'organization') {
                if (organiszation === '') {
                    hasError = true;
                }
                if (!props.isSocial) {
                    if (password === '' || confirmPassword === '' || password !== confirmPassword) {
                        hasError = true;
                        setPswError(true);
                    }
                   
                }
            }
            if (hasError) {
                setStepTwoError(true);
            } else {
                if (step < 2) {
                    setStep(step + 1);
                    setStepTwoError(false);
                }
            }
        }

        else if (step === 2) {
            if (userType === 'individual') 
                {
                if (
                    (country === '681dde46519da80203bdf80f' && (dob === "" || zip === "")) ||
                    (country !== '681dde46519da80203bdf80f' && dob === "")
                ) {
                    setStepThreeError(true);
                }
                else {
                    
                    setStepThreeError(false);
                    
                   
                    if (validateDob(new Date(dob)) ) {
                        setDobError("");
                        handleSignUp();
                    } 
                    else {
                        setDobError(
                            country === '681dde46519da80203bdf734'
                                ? "To register from Australia, you need to be at least 16 years old."
                                : "You must be at least 13 years old."
                        );
                    }
                }
            }

            else {
                if (bio === "") {
                    setStepThreeError(true);
                }
                else {
                    setStepThreeError(false)
                    handleSignUp();
                }
            }
        }
    };
    const handleSignUp = async () => {
        let formData = {};
        if (userType === 'individual') {
            formData = {
                firstname: firstName,
                lastname: lastName,
                usertype: userType,
                email: email,
                password: password,
                gender: gender,
                dob: moment(dob).format("YYYY-MM-DD"),
                zipcode: zip,
                community: communityId,
                membertype: selectedMemberType,
                communityname: newCommunity,
                location: location,
                country: country,
                socialmediaid: props.socialId,
                socialmediatype: props.socialType
            }
        }
        else {
            formData = {
                firstname: organiszation,
                usertype: userType,
                email: email,
                password: password,
                zipcode: zip,
                bio: bio,
                community: communityId,
                communityname: newCommunity,
                contactname: contactName,
                website: website,
                phonenumber: cell,
                taxid: einTax,
                organizationtype: orgType,
                location: location,
                country: country,
                socialmediaid: props.socialId,
                socialmediatype: props.socialType
            }
        }
        await ApiHelper.post(API.signup, formData)
            .then((resData) => {
                setSignUpStatus(resData.data.status)
                if (props.onSignUpSuccess) {
                    props.onSignUpSuccess(resData.data.status);
                }
                if (resData.data.status) {
                    const fixStyleAttributes = (html) => {
                        return html.replace(/style=["']([^"']+)["']/g, (match, styleContent) => {
                            const fixedStyle = styleContent
                                .replace(/([a-z])([A-Z])/g, '$1-$2') // Convert camelCase to kebab-case
                                .toLowerCase();
                            return `style="${fixedStyle}"`;
                        });
                    };
                    const fixedHtml = fixStyleAttributes(resData.data.message);
                    setSignupArr(fixedHtml)
                }

            })
            .catch((err) => {
                console.log(err);
            })

    }

    const back = (step) => {
        if (step > 0) setStep(step - 1);
        if (step === 0) props.handleClose();
        setStepOneError(false);
        setStepTwoError(false);
    };

    useEffect(() => {
        const remaining = MAX_COMMUNITY_LENGTH - newCommunity.length;
        setCommunityLimit({
            isOverLimit: remaining <= 0,
            remaining: remaining >= 0 ? remaining : 0,
        });
    }, [newCommunity]);

    const handleAcceptNumeric = (event) => {
        const inputValue = event.target.value;
      // Allow empty string or a string containing only digits AND enforce max length
        if ((inputValue === '' || /^\d+$/.test(inputValue)) && inputValue.length <= MAX_NUMERIC_INPUT_LENGTH) {
        setEinTax(inputValue);
        }
    };
    const handleValidPhone = (event) => {
        const inputValue = event.target.value;
      // Allow empty string or a string containing only digits AND enforce max length
        if ((inputValue === '' || /^\d+$/.test(inputValue)) && inputValue.length <= MAX_NUMERIC_INPUT_LENGTH) {
        setCell(inputValue);
        }
    };
   
    function isValidPassword(pwd) {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/.test(pwd);
    }

    function isValidName(name) {
    return /\d/.test(name);
    }
     
    const handleAcceptFirstName= (event) => {
        const inputValue = event.target.value;
      // Allow empty string or a string containing only letters
        if (inputValue === '' || /^[a-zA-Z ]*$/.test(inputValue)) {
        setFirstName(inputValue);
        }
    };
    const handleAcceptLastName= (event) => {
        const inputValue = event.target.value;
      // Allow empty string or a string containing only letters
        if (inputValue === '' || /^[a-zA-Z ]*$/.test(inputValue)) {
        setLastName(inputValue);
        }
    };
    const handleAcceptContactName= (event) => {
        const inputValue = event.target.value;
      // Allow empty string or a string containing only letters
        if (inputValue === '' || /^[a-zA-Z ]*$/.test(inputValue)) {
        setContactName(inputValue);
        }
    };


return (
        <div>
            <Modal show={props.isSignUp} onHide={props.handleClose} dialogClassName="custom-modal modal-dialog-centered modal-dialog-scrollable">
                <Modal.Header closeButton>
                    <div className="popupheader">
                        <div className="mod-bor-icon" >
                            <img src={thumb} className="mod-icon"></img>

                        </div>
                        <div className="header">
                            <h4 className="modal-tittle">Sign Up Now</h4>
                        </div>
                    </div>

                </Modal.Header>
                <Modal.Body className="d-flex flex-column justify-content-between" >
                    <div >
                        <Stepper activeStep={step}
                            size={2}
                            styleConfig={{
                                stepperContainerStyle: { padding: '24px 32px', },
                                connectorStyle: { height: '2px' },
                                stepButton: {
                                    height: '20px', // Adjust StepButton height
                                    width: '20px',  // Adjust StepButton width
                                    fontSize: '14px', // Font size for content inside StepButton
                                },
                                activeBgColor: '#2E7B88',
                                activeTextColor: '#fff',
                                completedBgColor: '#2E7B88',
                                connectorStateColors: true,
                                activeColor: '#2E7B88',
                                completedColor: '#2E7B88',
                                completedTextColor: '#fff',
                                padding: '12px 16px',  // May apply to StepButton too, depending on implementation
                                fontWeight: '400',
                            }}>
                            <Step label={<span style={{
                            }}>Communities</span>} />

                            <Step label={<span style={{
                            }}>Profile</span>} />

                            <Step label={<span style={{
                            }}>About Me</span>} />
                        </Stepper>

                        <div className="signup-dh-fields">
                            {step === 0 && (
                                <>
                                    <div className="row">
                                        <div className="col-lg-4" >
                                            <label htmlFor="exampleFormControlInput1" className="form-label user">
                                                User Type <span className="text-danger"> * </span>
                                            </label>
                                        </div>
                                        <div className="col-lg-8">
                                            <div className=" d-flex form-group custom-form-group">
                                                <div className="form-control gap-3 input-radio">
                                                    <div className=" d-flex">
                                                        <div className=" d-flex">
                                                            <input type="radio" name="payment" id="vessels"
                                                                className="vesselradio form-check-input radiobtn"
                                                                checked={userType === 'individual'}
                                                                value="individual" onChange={() => setUserType('individual')} />
                                                            <label htmlFor="vessels" className="vessel">
                                                                Individual
                                                            </label>

                                                        </div>
                                                        <div className=" d-flex">

                                                            <input type="radio" name="payment" id="services"
                                                                className="vesselradio form-check-input"
                                                                value="organization"
                                                                checked={userType === 'organization'}
                                                                onChange={() => setUserType('organization')} />
                                                            <label htmlFor="services" className="service">
                                                                Organization
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                     <div className="row">
                                        <label for="inputPassword" className="col-sm-4 col-form-label font ">Community <span className="text-danger"> * </span></label>
                                        <div className="col-sm-8 searchmain ">
                                            <div className="form-group custom-form-group">
                                                <i className="bi bi-search searchicon"></i>
                                                <input
                                                    type="text"
                                                    className="form-control search"
                                                    id="exampleFormControlInput2"
                                                    placeholder="Ex: Breast Cancer, Autism, etc"
                                                    value={community}
                                                    onChange={(e) => { e.preventDefault(); setCommunity(e.target.value); setCommunitySelected(true); setStepOneError(false); }}
                                                    autoComplete="off"
                                                />
                                            </div>
                                            {community === "" && stepOneError ? (
                                                <Validation message={'Please enter community'} />
                                            ) : null}

                                            {communityArr.length > 0 && communitySelected && (
                                                <ul className="select-dropdown">
                                                    {communityArr.map((item, index) => (
                                                        <li key={index} className="dropdown-item-radio">
                                                            <input
                                                                type="radio"
                                                                name="communityOption"
                                                                id={`option-${index}`}
                                                                value={item._id}
                                                                checked={community === item.communityName}
                                                                onChange={(e) => {
                                                                    e.preventDefault();
                                                                    setCommunity(item.communityName);
                                                                    setCommunityId(item._id)
                                                                    setCommunitySelected(false)
                                                                }} />
                                                            <label htmlFor={`option-${index}`} className="chooseanoption">
                                                                {item.communityName}
                                                            </label>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                            {communityId === "" && community !== "" && !hasSearched && stepOneError ? (
                                                <Validation message={'Please enter community'} />
                                            ) : null}
                                        </div>

                                    </div>
                                    {hasSearched && <div className="row search-no">
                                        <label for="inputPassword" className="col-sm-4 col-form-label font "></label>
                                        <div className="col-sm-8 searchmain ">

                                            <div className="form-group custom-form-group">
                                                <input type="email" className="form-control nocommunity " id="exampleFormCo
                                                    ntrolInput1" placeholder="Didn't See your Community listed?" readOnly />
                                            </div>
                                            <div className=" d-flex form-control input-radio align-items-center">
                                                <input type="checkbox" name="payment" id="vessels"
                                                    className="vesselradio form-check-input radiobtn"
                                                    onChange={(e) => { setIsNewCommunity(e.target.checked) }} checked={isNewCommunity ? 'checked' : ''} />

                                                <label htmlFor="vessels" className="vessel">
                                                    Create a New Community
                                                </label>

                                            </div>
                                        </div>

                                    </div>}
                                    {isNewCommunity && communityArr.length === 0 && <div className="mb-2 row">
                                        <label for="inputPassword" className="col-sm-4 col-form-label font ">Community Name <span className="text-dange"> * </span></label>

                                        <div className="col-sm-8">
                                            <small className="float-right text-muted">
                                                {communityLimit.remaining} characters remaining
                                                {communityLimit.isOverLimit && (
                                                    <span className="text-danger"> (Maximum reached)</span>
                                                )}
                                            </small>
                                            <textarea className={`form-control ${communityLimit.isOverLimit ? 'is-invalid' : ''}`} id="exampleFormControlTextarea1" rows="3"
                                            placeholder="Ex: Breast Cancer, Autism, etc"
                                                maxLength={MAX_COMMUNITY_LENGTH} onChange={(e) => { setNewCommunity(e.target.value) }} value={newCommunity}
                                                onBlur={handleCommunityVerification}></textarea>
                                            {newCommunity === "" && stepOneError ? (
                                                <Validation message={'Please enter you request'} />
                                            ) : null}
                                            {newCommunity !== "" && isCommunityExist ? (
                                                <Validation message={'Your requested community already exist'} />
                                            ) : null}
                                            {communityLimit.isOverLimit && (
                                                <div className="invalid-feedback">
                                                    Community name exceeds maximum length of {MAX_COMMUNITY_LENGTH} characters
                                                </div>
                                            )}
                                        </div>
                                    </div>}
                                    {userType === 'individual' &&
                                        <div className="row">
                                            <label for="inputPassword" className="col-sm-4 col-form-label font ">I'm joining this Community because... <span className="text-danger"> * </span></label>
                                            <div className="col-sm-8">
                                                <div className="form-group custom-form-group">
                                                    <select className="form-select font" aria-label="Default select example"
                                                        value={selectedMemberType}
                                                        onChange={e => setSelectedMemberType(e.target.value)}>
                                                        <option value="Select Member type" className="font">Select Member type</option>
                                                        {Array.isArray(communityMemberTypes) &&
                                                            communityMemberTypes.map((item) => (
                                                                <option key={item._id} value={item._id} className="font">
                                                                    {item.memberTypeName}
                                                                </option>
                                                            ))}
                                                    </select>
                                                    {selectedMemberType === "Select Member type" && stepOneError ? (
                                                        <Validation message={'Please select member type'} />
                                                    ) : null}
                                                </div>

                                            </div>
                                        </div>}
                                    {userType === 'organization' &&
                                        <>
                                            <div className="row">
                                                <label for="inputPassword" className="col-sm-4 col-form-label font ">Contact Name <span className="text-danger"> * </span></label>
                                                <div className="col-sm-8 searchmain ">
                                                    <div className="form-group custom-form-group">
                                                        <input type="text" className="form-control"
                                                            autoComplete="off"
                                                            autoCorrect="off"
                                                            autoCapitalize="off"
                                                            spellCheck="false"
                                                            onChange={handleAcceptContactName} value={contactName} />
                                                        {contactName === "" && stepOneError ? (
                                                            <Validation message={'Please enter contact name'} />
                                                        ) : null}
                                                        {isValidName(contactName) ? (
                                                            <Validation message={'Please enter a valid contact name'} />
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <label for="inputPassword" className="col-sm-4 col-form-label font ">Website <span className="text-danger"> * </span></label>
                                                <div className="col-sm-8 searchmain ">
                                                    <div className="form-group custom-form-group">
                                                        <input
                                                            type="text"
                                                            className="form-control search"
                                                            autoComplete="off"
                                                            autoCorrect="off"
                                                            autoCapitalize="off"
                                                            spellCheck="false"
                                                            placeholder="acs.com"
                                                            onChange={(e) => { setWebsite(e.target.value) }} value={website} />
                                                        {website === "" && stepOneError ? (
                                                            <Validation message={'Please enter website'} />
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <label for="inputPassword" className="col-sm-4 col-form-label font ">Phone Number <span className="text-danger"> * </span></label>
                                                <div className="col-sm-8 searchmain ">
                                                    <div className="form-group custom-form-group">
                                                        <input
                                                            type="text"
                                                            className="form-control search"
                                                            placeholder="63565323566"
                                                            onChange={handleValidPhone}
                                                            value={cell} 
                                                            maxLength={MAX_NUMERIC_INPUT_LENGTH} // <--- MAX LENGTH ADDED HERE
                                                        />
                                                        {cell === "" && stepOneError ? (
                                                            <Validation message={'Please enter Phone number'} />
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <label for="inputPassword" className="col-sm-4 col-form-label font ">Business Tax Id <span className="text-danger"> * </span></label>
                                                <div className="col-sm-8 searchmain ">
                                                    <div className="form-group custom-form-group">
                                                        <input
                                                            type="text"
                                                            className="form-control search"
                                                            placeholder="63565323566"
                                                            onChange={handleAcceptNumeric}
                                                            value={einTax}
                                                            maxLength={MAX_NUMERIC_INPUT_LENGTH} // <--- MAX LENGTH ADDED HERE
                                                        />
                                                          {einTax === "" && stepOneError ? (
                                                            <Validation message={'Please enter Business tax id'} />
                                                          ) : null}

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-4" >
                                                    <label htmlFor="exampleFormControlInput3" className="form-label user">
                                                        Organization Type <span className="text-danger"> * </span>
                                                    </label>
                                                </div>
                                                <div className="col-lg-8">
                                                    <div className="d-flex form-group custom-form-group">

                                                        <div className="form-control gap-3 input-radio">
                                                            <div className=" d-flex">
                                                                <div className=" d-flex">
                                                                    <input type="radio" id="non-profit"
                                                                        name="organizationType"
                                                                        className="vesselradio form-check-input radiobtn"
                                                                        checked={orgType === 'non-profit'}
                                                                        value="non-profit" onChange={() => setOrgType('non-profit')}
                                                                    />
                                                                    <label htmlFor="vessel" className="vessel">
                                                                        Non profit
                                                                    </label>
                                                                </div>
                                                                <div className=" d-flex">

                                                                    <input type="radio" name="organizationType" id="profit"
                                                                        className="vesselradio form-check-input"
                                                                        checked={orgType === 'profit'}
                                                                        value="profit" onChange={() => setOrgType('profit')}
                                                                    />
                                                                    <label htmlFor="services" className="service">
                                                                        For profit
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {orgType === "" && stepOneError ? (
                                                        <Validation message={'Please enter organization type'} />
                                                    ) : null}
                                                </div>

                                            </div>
                                        </>}
                                   
                                </>
                            )}

                             {step === 1 && (
                                <>
                                    {userType === 'organization' ?
                                        <div className="row">
                                            <label for="inputPassword" className="col-sm-4 col-form-label font ">Organization Name<span className="text-danger"> * </span>

                                            </label>
                                            <div className="col-sm-8">
                                                <small className="float-right text-muted">
                                                    {orgNameLimit.remaining} characters remaining
                                                    {orgNameLimit.isOverLimit && (
                                                        <span className="text-danger"> (Maximum reached)</span>
                                                    )}
                                                </small>
                                                <div className="form-group custom-form-group">

                                                    <input type="text" className={`form-control ${orgNameLimit.isOverLimit ? 'is-invalid' : ''}`} id="inputPassword" maxLength={MAX_ORG_NAME_LENGTH} onChange={(e) => { setOrganization(e.target.value) }} value={organiszation} />
                                                    {organiszation === "" && stepTwoError ? (
                                                        <Validation message={'Please enter organization'} />
                                                    ) : null}
                                                    {orgNameLimit.isOverLimit && (
                                                        <div className="invalid-feedback">
                                                            Organization name exceeds maximum length of {MAX_ORG_NAME_LENGTH} characters
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div> :
                                        <>
                                            <div className="row">
                                                <label for="inputPassword" className="col-sm-4 col-form-label font ">First Name <span className="text-danger"> * </span></label>
                                                <div className="col-sm-8">
                                                    <div className="form-group custom-form-group">
                                                        <input type="text" className="form-control" id="inputPassword" onChange={handleAcceptFirstName} value={firstName} />
                                                        {firstName === "" && stepTwoError ? (
                                                            <Validation message={'Please enter first name'} />
                                                        ) : null}
                                                         {isValidName(firstName)  ? (
                                                            <Validation message={'Please enter a valid first name'} />
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <label for="inputPassword" className="col-sm-4 col-form-label font ">Last Name <span className="text-danger"> * </span></label>
                                                <div className="col-sm-8">
                                                    <div className="form-group custom-form-group">
                                                        <input type="text" className="form-control" id="inputPassword" onChange={handleAcceptLastName} value={lastName} />
                                                        {lastName === "" && stepTwoError ? (
                                                            <Validation message={'Please enter last name'} />
                                                        ) : null}
                                                        {isValidName(lastName)  ? (
                                                        <Validation message={'Please enter a valid last name'} />
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div></>}
                                    <div className="row">
                                        <label for="inputPassword" className="col-sm-4 col-form-label font ">Email <span className="text-danger"> * </span></label>
                                        <div className="col-sm-8">
                                            <div className="form-group custom-form-group">
                                                <input
                                                    type="text"
                                                    name="email" // Use real name temporarily
                                                    autoComplete="email"
                                                    style={{ display: 'none' }}
                                                />
                                                <input type="text" className="form-control" id="inputPassword"
                                                    name="emailPreventAutoFill" // not a common name like "email"
                                                    autoComplete="new-password"
                                                    readOnly={!props.isSocial ? true : true}
                                                    onFocus={(e) => { if (!props.isSocial) { e.target.removeAttribute("readonly"); } }}
                                                    autoCorrect="off"
                                                    autoCapitalize="off"
                                                    spellCheck="false"
                                                    onChange={(e) => { setEmail(e.target.value); setEmailError(false); setIsEmailExist(false) }} value={email}
                                                    onBlur={handleEmailVerification} />
                                                {isEmailExist ? <Validation message={'Email already exists'} /> : null}
                                                {emailError && <Validation message={'Please enter valid email'} />}
                                                {email === "" && stepTwoError ? (
                                                    <Validation message={'Please enter email'} />
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    {!props.isSocial && <div className="row">
                                        <label for="inputPassword" className="col-sm-4 col-form-label font ">Password <span className="text-danger"> * </span></label>
                                        <div className="col-sm-8 position-relative">
                                            <div className="form-group custom-form-group">
                                                <input type={showPassword ? "text" : "password"} className="form-control" id="inputPassword"
                                                    autoComplete="off"
                                                    autoCorrect="off"
                                                    autoCapitalize="off"
                                                    spellCheck="false"
                                                    onChange={(e) => { setPassword(e.target.value) }} value={password} />
                                                <i
                                                    className={`bi ${showPassword ? 'bi-eye' : 'bi-eye-slash'} mt-3 eye-icon password-icon`}
                                                    style={{ marginRight: '13px' }}
                                                    onClick={() => setShowPassword(!showPassword)}
                                                ></i>
                                                {password === "" && stepTwoError ? (
                                                    <Validation message={'Please enter the password'} />
                                                ) : null}
                                                {(!isValidPassword(password)) && stepTwoError?(
                                            <div className="valmsg">
                                                <Validation message={'Password must include uppercase,lowercase,number,symbol and be atleast 8 characters long'} />
                                            </div>
                                         ):null}
                                            </div>
                                        </div>
                                    </div>}
                                    {!props.isSocial && <div className="row">
                                        <label for="inputPassword" className="col-sm-4 col-form-label font ">Confirm Password <span className="text-danger"> * </span></label>
                                        <div className="col-sm-8 position-relative">
                                            <div className="form-group custom-form-group">
                                                <input type={showPasswordConfirm ? "text" : "password"} className="form-control" id="inputPassword"
                                                    autoComplete="off"
                                                    autoCorrect="off"
                                                    autoCapitalize="off"
                                                    spellCheck="false"
                                                    onChange={(e) => { setConfirmPassword(e.target.value) }} value={confirmPassword}
                                                    onBlur={handlePassword} />
                                                <i
                                                    className={`bi ${showPasswordConfirm ? 'bi-eye' : 'bi-eye-slash'} mt-3 eye-icon password-icon`}
                                                    style={{ marginRight: '13px' }}
                                                    onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                                                ></i>
                                                {confirmPassword === "" && stepTwoError ? (
                                                    <Validation message={'Please enter the confirm password'} />
                                                ) : null}
                                                {confirmPassword !== "" && password !== "" && pswerror ? <Validation message={'Passwords do not match'} /> : null}
                                            </div>
                                        </div>
                                    </div>}
                                </>
                            )}

                            {step === 2 && signUpStatus === "" && (
                                <>
                                    {userType === 'individual' &&
                                        <div className="row">
                                            <label for="inputPassword" className="col-sm-4 col-form-label font ">Gender </label>
                                            <div className="col-sm-8">
                                                <div className="form-group custom-form-group">
                                                    <select className="form-select font" aria-label="Default select example"
                                                        onChange={(e) => { setGender(e.target.value) }} value={gender}>
                                                        <option value='' className="font">Select Gender</option>
                                                        <option value="Male" className="font">Male</option>
                                                        <option value="Female" className="font">Female</option>
                                                    </select>

                                                </div>
                                            </div>
                                        </div>}
                                    {userType === 'individual' &&
                                        <div className="row">
                                            <label for="inputPassword" className="col-sm-4 col-form-label font ">Date of Birth <span className="text-danger"> * </span></label>
                                            <div className="col-sm-8 position-relative" >
                                                <div className="form-group custom-form-group d-none">
                                                    <Datetime
                                                        dateFormat="MM/DD/YYYY"
                                                        inputProps={{
                                                            onFocus: handleFocus,
                                                            placeholder: 'e.g. 01/21/2025'
                                                        }}
                                                        timeFormat={false}
                                                        open={isCalendarOpen}
                                                        value={dob}
                                                        
                                                        onChange={handleChange}
                                                    />
                                                    <img className='mt-3 password-icon' style={{ marginRight: '10px', height: '18px', width: '18px' }}
                                                        src={Calender} onClick={() => setIsCalendarOpen(!isCalendarOpen)} />
                                                    {dob === "" && stepThreeError ? (
                                                        <Validation message={'Please enter date of birth'} />
                                                    ) : null}
                                                    
                                                    {dobError &&
                                                        <Validation message={dobError} />}
                                                </div>
                                                <div className="dob-splitter form-group custom-form-group">
                                                                                    <div className="splitter-itm">
                                                                                        <div className="form-input">
                                                                                            
                                                                                            <Form.Select  aria-label="Default select example" placeholder="Month"
                                                                                                value={month}
                                                                                                onChange={(e) => setMonth(e.target.value)}>
                                                                                                    <option value="">Month</option>
                                                                                                {months.map((m) => (
                                                                                                <option key={m.value} value={m.value}>
                                                                                                    {m.label}
                                                                                                </option>
                                                                                                ))}
                                                                                            </Form.Select>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="splitter-itm">
                                                                                        <div className="form-input">
                                                                                            <input type="number" className="form-control"
                                                                                            placeholder="Day"
                                                                                            value={day}
                                                                                            //onChange={(e) => setDay(e.target.value)}
                                                                                             onChange={(e) => {
                                                                                                const val = e.target.value;
                                                                                                if (val === '') setDay('');
                                                                                                else {
                                                                                                const num = Math.min(Math.max(parseInt(val), 1), 31);
                                                                                                setDay(num.toString());
                                                                                                }
                                                                                            }}
                                                                                            min="1"
                                                                                            max="31" />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="splitter-itm">
                                                                                        <div className="form-input">
                                                                                            <input  type="number" className="form-control"
                                                                                            placeholder="Year"
                                                                                            value={year}
                                                                                           
                                                                                           onChange={(e) => {
                                                                                                // Just update the raw text
                                                                                                setYear(e.target.value);
                                                                                            }}
                                                                                            onBlur={(e) => {
                                                                                                const val = e.target.value;
                                                                                                if (val === '') return;
                                                                                                const num = Math.min(Math.max(parseInt(val), 1910), 2200);
                                                                                                setYear(num.toString());
                                                                                            }}
                                                                                            min="1910"
                                                                                            max={new Date().getFullYear()}/>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                
                                                    {(stepThreeError && (!month || !day || !year)) && (
                                    <Validation message="Please enter date of birth" />
                                )}
                                                    {dobError &&
                                                        <Validation message={dobError} />}
                                                        {dateError &&
                                                                                            <Validation message={dateError} />}
                                            </div>
                                        </div>}
                                    <div className="row">
                                        <label for="inputPassword" className="col-sm-4 col-form-label font ">Country {<span className="text-danger"> * </span>}</label>
                                        <div className="col-sm-8">
                                            <div className="form-group custom-form-group">
                                                <select className="form-select font" aria-label="Default select example"
                                                    value={country}
                                                    onChange={e => {setCountry(e.target.value); setDobError("")}}>
                                                    {Array.isArray(countryArr) &&
                                                        countryArr.map((item) => (
                                                            <option key={item._id} value={item._id} className="font">
                                                                {item.countryName}
                                                            </option>
                                                        ))}
                                                </select>
                                                {userType === 'organization' && country === "" && stepThreeError ? (
                                                    <Validation message={'Please choose country'} />
                                                ) : null}

                                            </div>
                                        </div>
                                    </div>
                                    {country === '681dde46519da80203bdf80f' &&
                                        <div className="row">
                                            <label for="inputPassword" className="col-sm-4 col-form-label font ">Zip Code {<span className="text-danger"> * </span>}</label>
                                            <div className="col-sm-8">
                                                <div className="form-group custom-form-group">
                                                    <input type="text" className="form-control" id="inputPassword"
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (/^\d{0,5}$/.test(value)) { // restricts to 0–5 digits only
                                                                setZip(value);
                                                            }
                                                        }}
                                                        value={zip} />
                                                    {userType === 'organization' && zip === "" && stepThreeError ? (
                                                        <Validation message={'Please enter zip code'} />
                                                    ) : null}
                                                    {userType === 'individual' && zip === "" && stepThreeError ? (
                                                        <Validation message={'Please enter zip code'} />
                                                    ) : null}
                                                    {zip && !/^\d{5}$/.test(zip) && (
                                                        <Validation message="ZIP code must be exactly 5 digits" />
                                                    )}
                                                </div>
                                            </div>
                                        </div>}
                                    {userType === 'organization' &&
                                        <div className="row">
                                            <label for="inputPassword" className="col-sm-4 col-form-label font ">Description <span className="text-danger"> * </span></label>
                                            <div className="col-sm-8">
                                                <div className="form-roup custom-form-group">
                                                    <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" onChange={(e) => { setBio(e.target.value) }} value={bio}></textarea>
                                                    {bio === "" && stepThreeError ? (
                                                        <Validation message={'Please enter Bio'} />
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>}
                                </>
                            )}
                            {signUpStatus && step === 2 && signupArr &&
                                <div style={{ textAlign: 'center', padding: '30px 0' }}
                                    dangerouslySetInnerHTML={{ __html: signupArr }} />

                            }
                        </div>
                    </div>
                    <div className="mb-2 mt-3 disclimer">
                        <i class="bi bi-exclamation-triangle-fill"></i>
                        <p className="sty-logg-join-comm mb-0">We are asking you this information to personalize your experience and help you
                            find people just like you</p>
                    </div>
                </Modal.Body>
                {signUpStatus === "" &&
                    <Modal.Footer className="full-w" >
                        <button type="button" className="cancel-btn" onClick={() => back(step)} >
                            Cancel
                        </button>
                        <button className="next-btn" onClick={() => next(step)}>
                            {" "} Save & Next{" "}
                        </button>
                    </Modal.Footer>
                }
                {loader && <Spinner />}
            </Modal>

        </div >
    );
};
export default SignUp;